import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import Keycloak from 'keycloak-js';

import { dwmRole } from '../../enums/roles';
import { FeatureType } from '../../generated';
import { FeatureService } from '../../generated/api/feature.service';
import { CustomSnackbarService } from '../../services/custom-snacakbar.service';
import { SharedActions } from '../../store/shared.actions';
import { HoverMenuComponent } from '../hover-menu/hover-menu.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-navigation',
  imports: [MatMenuModule, MatIconModule, HoverMenuComponent, RouterModule],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly actions = inject(Actions);
  private readonly customSnackbarService = inject(CustomSnackbarService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly featureService = inject(FeatureService);

  /** Platform operator: only the /admin page; the API gives it no company data. */
  isSuperAdmin = false;
  /** Sees everything a company user sees, regardless of which of the two roles it holds. */
  isUser = false;
  featureTypes: FeatureType[] = [];
  readonly FeatureType = FeatureType;
  isComplaint0KmEnabled = false;
  isSupplyOnEnabled = false;
  isPocFormEnabled = false;

  private readonly keycloak = inject(Keycloak);

  ngOnInit() {
    this.isSuperAdmin = this.keycloak.hasRealmRole(dwmRole.SUPERADMIN);
    // A company admin is a user who can also manage document folders.
    this.isUser =
      (this.keycloak.hasRealmRole(dwmRole.USER) ||
        this.keycloak.hasRealmRole(dwmRole.ADMIN)) &&
      !this.isSuperAdmin;
    this.getFeatureTypes();
    this.featureService.apiFeaturesKeyGet('Complaint0Km').subscribe({
      next: (enabled: boolean) => (this.isComplaint0KmEnabled = enabled),
      error: () => (this.isComplaint0KmEnabled = false)
    });
    this.featureService.apiFeaturesKeyGet('SupplyOn').subscribe({
      next: (enabled: boolean) => (this.isSupplyOnEnabled = enabled),
      error: () => (this.isSupplyOnEnabled = false)
    });
    this.featureService.apiFeaturesKeyGet('PocForm').subscribe({
      next: (enabled: boolean) => (this.isPocFormEnabled = enabled),
      error: () => (this.isPocFormEnabled = false)
    });
  }

  getFeatureTypes() {
    this.store.dispatch(SharedActions.getFeatureTypes());

    this.actions
      .pipe(
        ofType(SharedActions.getFeatureTypesSuccess),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((payload) => {
        this.featureTypes = payload.featureTypes;
      });

    this.actions
      .pipe(
        ofType(SharedActions.getFeatureTypesError),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.customSnackbarService.openError(
          'Error while loading feature types'
        );
      });
  }
}
